import { useMemo } from 'react';
import textAdditionalClassName from '../../../helpers/utils/TextAdditionalClassName';

interface BodyLargeProps {
  children: React.ReactNode;
  className?: string;
  maxLines?: number;
  isClamp?: boolean;
  style?: React.CSSProperties;
  textBreak?: 'words' | 'characters';
  overflow?: 'hidden' | 'visible';
}

const BodyLarge = ({
  children,
  maxLines = 2,
  isClamp = false,
  className = '',
  style = {},
  textBreak = 'words',
  overflow = 'hidden',
  ...props
}: BodyLargeProps & React.ComponentProps<'p'>) => {
  const lineClampStyle: React.CSSProperties = isClamp
    ? {
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        display: '-webkit-box',
      }
    : {};

  const additionalClassName = useMemo(
    () => textAdditionalClassName(textBreak, overflow),
    [textBreak, overflow]
  );

  return (
    <p
      style={{ ...lineClampStyle, ...style }}
      className={`text-[16px] leading-[24px] break-words text-black90 ${additionalClassName} ${className}`}
      {...props}
    >
      {children}
    </p>
  );
};

export default BodyLarge;
